// NotFound.jsx
import { Link } from "react-router-dom";
import { MoveLeft } from 'lucide-react'; // Optional icon for the button

const NotFound = () => {
    return (
        <div className="relative min-h-screen flex items-center justify-center bg-gray-50 px-4 overflow-hidden">
            {/* Background Decorative Element - Large 404 Watermark */}
            <div className="absolute inset-0 flex items-center justify-center opacity-[0.03] select-none pointer-events-none">
                <h1 className="text-[30rem] font-bold Ethnocentric">404</h1>
            </div>

            <div className="relative z-10 text-center max-w-2xl">
                {/* Visual Icon/Number */}
                <div className="mb-8 relative inline-block">
                    <h1 className="text-8xl md:text-9xl Ethnocentric text-brand-500 animate-pulse">
                        404
                    </h1>
                    <div className="absolute -bottom-2 left-0 w-full h-2 bg-brand-600 rounded-full blur-sm opacity-50"></div>
                </div>

                <div className="space-y-6">
                    <h2 className="text-2xl md:text-4xl Ethnocentric text-gray-900 uppercase tracking-tight">
                        Oops! Page not found.
                    </h2>
                    
                    <p className="text-gray-500 text-lg max-w-md mx-auto leading-relaxed">
                        The package you're looking for seems to have taken a wrong turn. 
                        The page you’re looking for doesn’t exist or has been moved.
                    </p>

                    <div className="pt-8">
                        <Link
                            to="/"
                            className="inline-flex items-center gap-3 bg-brand-600 ha:bg-brand-700 text-white px-8 py-4 rounded-xl font-bold uppercase tracking-widest transition-all duration-300 transform ha:scale-105 ha:shadow-xl ha:shadow-brand-500/20 group"
                        >
                            <MoveLeft size={20} className="gh:-translate-x-2 transition-transform" />
                            Go back to Home
                        </Link>
                    </div>
                </div>

                {/* Subtle Support Link */}
                <p className="mt-12 text-sm text-gray-400">
                    Need help? <Link to="/contact" className="text-brand-500 ha:underline">Contact our support team</Link>
                </p>
            </div>
        </div>
    );
};

export default NotFound;